import { AppRouteObject } from '@frontend/core/lib/modules/app/types'
import { useAppSelector } from '../store/hooks'
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator
} from '@frontend/ui'
import React from 'react'
import { Link } from 'react-router-dom'
import { useBreadcrumbs } from '@frontend/react/app/hooks'

export const SportableBreadcrumbs = ({
  selectedRoute
}: {
  selectedRoute: AppRouteObject
}) => {
  const appConfig = useAppSelector((state) => state.app.config)
  const breadcrumbs = useBreadcrumbs(appConfig, selectedRoute)

  return (
    <Breadcrumb>
      <BreadcrumbList>
        {breadcrumbs?.map((crumb, idx) => (
          <React.Fragment key={crumb.path}>
            <BreadcrumbItem>
              {idx < breadcrumbs.length - 1 ? (
                <Link to={crumb.path}>{crumb.name}</Link>
              ) : (
                <BreadcrumbPage>{crumb.name}</BreadcrumbPage>
              )}
            </BreadcrumbItem>
            {idx < breadcrumbs.length - 1 && <BreadcrumbSeparator />}
          </React.Fragment>
        ))}
      </BreadcrumbList>
    </Breadcrumb>
  )
}
